"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Footer = exports.InfoBox = exports.Item = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styles = require("@material-ui/core/styles");

var _Button = _interopRequireDefault(require("@material-ui/core/Button"));

var _Card = _interopRequireDefault(require("@material-ui/core/Card"));

var _CardHeader = _interopRequireDefault(require("@material-ui/core/CardHeader"));

var _CardContent = _interopRequireDefault(require("@material-ui/core/CardContent"));

var _Typography = _interopRequireDefault(require("@material-ui/core/Typography"));

var _ListItem = _interopRequireDefault(require("@material-ui/core/ListItem"));

var _ListItemAvatar = _interopRequireDefault(require("@material-ui/core/ListItemAvatar"));

var _ListItemText = _interopRequireDefault(require("@material-ui/core/ListItemText"));

var _Avatar = _interopRequireDefault(require("@material-ui/core/Avatar"));

var _reactFontawesome = require("@fortawesome/react-fontawesome");

var _faCommentAlt = require("@fortawesome/free-regular-svg-icons/faCommentAlt");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CARD_BORDER_COLOR = '#E0E0E0';
var DEFAULT_BUTTON_COLOR = '#2697FF';
var useStylesItem = (0, _styles.makeStyles)({
  root: {
    padding: '16px 18px'
  },
  avatar: {
    width: '60px',
    height: '60px',
    borderRadius: '4px',
    marginRight: '11px'
  },
  text: {
    margin: '0px'
  },
  textPrimary: {
    fontWeight: '500',
    fontSize: '18px',
    lineHeight: '22px',
    display: 'block',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis'
  }
}, {
  name: 'Mui-WidgetDiscussionItem'
});

var Item = (_ref) => {
  var {
    imageUrl,
    userName,
    name,
    message,
    timeSince,
    onClick,
    url
  } = _ref;
  var classes = useStylesItem();
  return /*#__PURE__*/_react.default.createElement(_ListItem.default, {
    component: "a",
    disableGutters: true,
    button: true,
    className: classes.root,
    onClick: onClick,
    href: url
  }, /*#__PURE__*/_react.default.createElement(_ListItemAvatar.default, null, /*#__PURE__*/_react.default.createElement(_Avatar.default, {
    className: classes.avatar,
    src: imageUrl
  }, /*#__PURE__*/_react.default.createElement(_reactFontawesome.FontAwesomeIcon, {
    icon: _faCommentAlt.faCommentAlt,
    size: "lg"
  }))), /*#__PURE__*/_react.default.createElement(_ListItemText.default, {
    className: classes.text,
    primaryTypographyProps: {
      className: classes.textPrimary
    },
    primary: name,
    secondary: [/*#__PURE__*/_react.default.createElement(_Typography.default, {
      key: "".concat(name, "-message"),
      component: "span",
      display: "block",
      variant: "body2",
      color: "textPrimary",
      noWrap: true
    }, userName && "".concat(userName, ": "), " ", message), /*#__PURE__*/_react.default.createElement(_Typography.default, {
      key: "".concat(name, "-timeSince"),
      component: "span",
      variant: "body2",
      display: "block",
      noWrap: true
    }, timeSince)]
  }));
};

exports.Item = Item;
Item.propTypes = {
  /**
   * Avatar image
   */
  imageUrl: _propTypes.default.string,

  /**
   * User name who sent last message
   */
  userName: _propTypes.default.string,

  /**
   * Discussion name
   */
  name: _propTypes.default.string.isRequired,

  /**
   * Last sent message
   */
  message: _propTypes.default.string,

  /**
   * Last send message last updated time
   */
  timeSince: _propTypes.default.string,

  /**
   * Item click Action
   */
  onClick: _propTypes.default.func,

  /**
   *
   * Passed as href to listItem
   */
  url: _propTypes.default.string
};
var useStylesInfoBox = (0, _styles.makeStyles)({
  root: {
    textAlign: 'center',
    top: 'calc(50% + 83px / 2)',
    position: 'relative',
    transform: 'translateY(-50%)'
  },
  message: {
    fontWeight: '500',
    fontSize: '16px',
    lineHeight: '20px'
  },
  button: {
    marginTop: '15px'
  }
}, {
  name: 'Mui-WidgetDiscussionInfoBox'
});

var InfoBox = (_ref2) => {
  var {
    message,
    actionTitle,
    actionOnClick,
    url,
    color = DEFAULT_BUTTON_COLOR
  } = _ref2;
  var classes = useStylesInfoBox();
  return /*#__PURE__*/_react.default.createElement("div", {
    className: classes.root
  }, /*#__PURE__*/_react.default.createElement(_Typography.default, {
    className: classes.message
  }, message), actionTitle && /*#__PURE__*/_react.default.createElement(_Button.default, {
    component: "a",
    variant: "outlined",
    className: classes.button,
    onClick: actionOnClick,
    href: url,
    style: {
      borderColor: color,
      color
    }
  }, actionTitle));
};

exports.InfoBox = InfoBox;
InfoBox.propTypes = {
  /**
   * InfoBox for no discussion message or login
   */
  message: _propTypes.default.string.isRequired,

  /**
   * Button Action
   */
  actionTitle: _propTypes.default.string,

  /**
   * Button Action
   */
  actionOnClick: _propTypes.default.func,

  /**
   * Passed as href to action button
   */
  url: _propTypes.default.string,

  /**
   * color for the button
   */
  color: _propTypes.default.string
};
var useFooterStlyes = (0, _styles.makeStyles)({
  root: {
    padding: '23px',
    borderTop: "1px solid ".concat(CARD_BORDER_COLOR),
    display: 'flex',
    alignItems: 'center'
  },
  button: {
    margin: 'auto'
  }
}, {
  name: 'Mui-WidgetDiscussionFooter'
});

var Footer = (_ref3) => {
  var {
    title,
    onClick,
    url,
    color = DEFAULT_BUTTON_COLOR
  } = _ref3;
  var classes = useFooterStlyes();
  return /*#__PURE__*/_react.default.createElement("div", {
    className: classes.root
  }, /*#__PURE__*/_react.default.createElement(_Button.default, {
    component: "a",
    variant: "outlined",
    className: classes.button,
    onClick: onClick,
    href: url,
    style: {
      borderColor: color,
      color
    }
  }, title));
};

exports.Footer = Footer;
Footer.propTypes = {
  /**
   * Title for the footer button
   */
  title: _propTypes.default.string.isRequired,

  /**
   * Callback function will be triggered when user click on footer button
   */
  onClick: _propTypes.default.func.isRequired,

  /**
   * Passed as href to button
   */
  url: _propTypes.default.string,

  /**
   * Color for the button
   */
  color: _propTypes.default.string
};
var useStyles = (0, _styles.makeStyles)({
  root: {
    borderColor: CARD_BORDER_COLOR,
    height: 'inherit',
    minHeight: '630px'
  },
  header: {
    padding: '24px 18px 13px',
    borderBottom: "1px solid ".concat(CARD_BORDER_COLOR)
  },
  title: {
    fontSize: '20px',
    fontWeight: '500',
    lineHeight: '24px'
  },
  content: {
    padding: '0px',
    height: 'calc(100% - 152px)',
    overflow: 'hidden'
  }
}, {
  name: 'Mui-WidgetDiscussion'
});

var Discussion = (_ref4) => {
  var {
    title,
    children,
    footer
  } = _ref4;
  var classes = useStyles();
  return /*#__PURE__*/_react.default.createElement(_Card.default, {
    variant: "outlined",
    className: classes.root
  }, /*#__PURE__*/_react.default.createElement(_CardHeader.default, {
    title: title,
    classes: {
      root: classes.header,
      title: classes.title
    }
  }), /*#__PURE__*/_react.default.createElement(_CardContent.default, {
    className: classes.content
  }, children), footer);
};

Discussion.propTypes = {
  /**
   * Title for the widget
   */
  title: _propTypes.default.string.isRequired,

  /**
   * Discussion container prop:  List of item components as children with data
   */
  children: _propTypes.default.node,

  /**
   * Footer for Discussion widget
   */
  footer: _propTypes.default.node
};
var _default = Discussion;
exports.default = _default;